"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Application;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Page = _interopRequireDefault(require("../components/Page"));

function Application(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_Page.default, null, children);
}

Application.propTypes = {
  children: _propTypes.default.object
};
module.exports = exports.default;